import PropTypes from 'prop-types';
import { BestsellerBadge } from '../badges/bestseller_badge';
import { Buy4For3Badge } from '../badges/buy_4_for_3_badge';
import { ClearanceBadge } from '../badges/clearance_badge';
import { InstantCashBadge } from '../badges/instant_cash_badge';
import { NewProductBadge } from '../badges/new_product_badge';
import { SavePercentBadge } from '../badges/save_percent_badge';
import { TyroolasChoiceBadge } from '../badges/tyroolas_choice_badge';
import GiftCard from '../badges/GiftCard';
import { CurrentCurrencySetup } from '../../../_modules/currency/current_currency_setup';
import formatToCurrency from '../../../_modules/currency/format_to_currency';
import { Badge } from "../badges/badge";
import {SavePercentOnxTyresBadge} from "../badges/save_percent_badge_on_x_tyres";

const TYPES = {
    BUY4PAY3: 'buy-4-pay-3',
    INSTANT_CASH: 'instant-cash',
    NEW_PRODUCT: 'new',
    SAVE_PERCENT: 'save-percent',
    CLEARANCE: 'clearance',
    TYROOLAS_CHOICE: 'tyroolas-choice',
    BEST_SELLER: 'bestseller',
    GIFT_CARD: 'gift-card'
}
const currentCurrencySetup = CurrentCurrencySetup.getCurrentCurrencySetup();

export const BadgeSelector = ({ type, color, text, discountValue, matchedProdQtyMultiplier }) => {
    let elem;
    if (TYPES.SAVE_PERCENT === type && matchedProdQtyMultiplier > 0) {
        elem = <SavePercentOnxTyresBadge percent={discountValue} amountTyres={matchedProdQtyMultiplier} />
        return elem;
    }
    switch (type) {
        case TYPES.BUY4PAY3:
            elem = <Buy4For3Badge color={color} />
            break;
        case TYPES.INSTANT_CASH:
            elem = <InstantCashBadge color={color} amountCash={formatToCurrency(discountValue, currentCurrencySetup.isoCode, false, true)} amountTyres={4} />
            break;
        case TYPES.NEW_PRODUCT:
            elem = <NewProductBadge color={color} />;
            break;
        case TYPES.SAVE_PERCENT:
            elem = <SavePercentBadge color={color} percent={discountValue} />
            break;
        case TYPES.CLEARANCE:
            elem = <></>;
            break;
        case TYPES.TYROOLAS_CHOICE:
            elem = <TyroolasChoiceBadge color={color} />
            break;
        case TYPES.BEST_SELLER:
            elem = <BestsellerBadge color={color} />
            break;

        case TYPES.GIFT_CARD:
            elem = <GiftCard color={color} text={text} type={'primary'} />
            break;
        default:
            elem = <Badge color={color} badgeText={text} />
            break;
    }
    return elem;
}

BadgeSelector.propTypes = {
    type: PropTypes.string.isRequired,
    text: PropTypes.string,
    color: PropTypes.string,
    discountValue: PropTypes.number
};

BadgeSelector.defaultProps = {
    text: '',
    color: 'blue',
    discountValue: 0
};

